import { Language } from '@/@types/global-types'
import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import militaryLoaderExpCalendarEn from '@/assets/landing-activity-male/military-loader-exp-calendar-2x.webp'
import militaryLoaderExpCalendarDa from '@/assets/landing-activity-male/military-loader-exp-calendar-da-2x.webp'
import militaryLoaderExpCalendarDe from '@/assets/landing-activity-male/military-loader-exp-calendar-de-2x.webp'
import militaryLoaderExpCalendarEs from '@/assets/landing-activity-male/military-loader-exp-calendar-es-2x.webp'
import militaryLoaderExpCalendarEs419 from '@/assets/landing-activity-male/military-loader-exp-calendar-es-419-2x.webp'
import militaryLoaderExpCalendarFr from '@/assets/landing-activity-male/military-loader-exp-calendar-fr-2x.webp'
import militaryLoaderExpCalendarIt from '@/assets/landing-activity-male/military-loader-exp-calendar-it-2x.webp'
import militaryLoaderExpCalendarJa from '@/assets/landing-activity-male/military-loader-exp-calendar-ja-2x.webp'
import militaryLoaderExpCalendarNb from '@/assets/landing-activity-male/military-loader-exp-calendar-nb-2x.webp'
import militaryLoaderExpCalendarNl from '@/assets/landing-activity-male/military-loader-exp-calendar-nl-2x.webp'
import militaryLoaderExpCalendarPl from '@/assets/landing-activity-male/military-loader-exp-calendar-pl-2x.webp'
import militaryLoaderExpCalendarPt from '@/assets/landing-activity-male/military-loader-exp-calendar-pt-2x.webp'
import militaryLoaderExpCalendarSv from '@/assets/landing-activity-male/military-loader-exp-calendar-sv-2x.webp'
import militaryLoaderExpCalendarTr from '@/assets/landing-activity-male/military-loader-exp-calendar-tr-2x.webp'

const CALENDAR_BY_LANGUAGE: Partial<Record<Language, string>> = {
	da: militaryLoaderExpCalendarDa,
	de: militaryLoaderExpCalendarDe,
	es: militaryLoaderExpCalendarEs,
	'es-419': militaryLoaderExpCalendarEs419,
	fr: militaryLoaderExpCalendarFr,
	it: militaryLoaderExpCalendarIt,
	ja: militaryLoaderExpCalendarJa,
	nb: militaryLoaderExpCalendarNb,
	nl: militaryLoaderExpCalendarNl,
	pl: militaryLoaderExpCalendarPl,
	pt: militaryLoaderExpCalendarPt,
	sv: militaryLoaderExpCalendarSv,
	tr: militaryLoaderExpCalendarTr,
}

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			config: {
				background: 'dark',
			},
			order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],
			components: {
				LandingHead: (): LandingComponentsConfig['LandingHead'] => ({
					logoAlignment: 'center',
					logoColor: 'white',
				}),

				LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => ({
					img: CALENDAR_BY_LANGUAGE[ctx.language] ?? militaryLoaderExpCalendarEn,
					customStyles: {
						marginBottom: 'var(--size-30)',
					},
				}),

				LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
					title: $t('military_calisthenics.pages.landing.loader.teaser_title'),
					size: 'medium',
					customStyles: {
						color: 'var(--Text-Primary-White, #ffffff)',
						textAlign: 'center',
						fontSize: 'var(--size-24)',
						marginBottom: 'var(--size-26)',
					},
				}),

				LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
					duration: 3500,
					theme: 'white',
				}),

				LandingFooter: (): LandingComponentsConfig['LandingFooter'] => ({
					textColor: 'white',
				}),
			},
		},
		{},
	]

	return mergeDeep([...schemas], extensionSchema)
}
